import { Injectable } from '@angular/core';
import { Language } from './lang.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';

@Injectable()
export class LangStaticDataSource {
  private Lang: Language[] = [
    /*0*/  new Language('Шығу', 'Выйти'),
    /*1*/  new Language('Іздеу', 'Поиск'),
    /*2*/  new Language('Результаты конкурса грантов', 'Результаты конкурса грантов'),
    /*3*/  new Language('Кіру', 'Войти'),
    /*4*/  new Language('Ұлттық тестілеу орталығы', 'Национальный центр тестирования'),
    /*5*/  new Language('Cерия', 'Серия '),
    /*6*/  new Language('Сертификаттың нөмірі', 'Номер сертификата'),
    /*7*/  new Language('Жыл', 'Год'),
    /*8*/  new Language('Тест түрін таңдаңыз', 'Выберите тип тестирования'),
    /*9*/  new Language('ТЖК енгізіңіз', 'Введите ИКТ'),
    /*10*/  new Language('Серия және нөмір арқылы іздеу', 'поиск по серии и по номеру сертификата'),
    /*11*/  new Language('Сертификатты тексеру', 'Проверка сертификата'),
    /*12*/  new Language('Логинді енгізіңіз', 'Введите логин'),
    /*13*/  new Language('Құпиясөзді енгізіңіз', 'Введите пароль'),
    /*14*/  new Language('ТӘЖ', 'ФИО'),
    /*15*/  new Language('Аты', 'Имя'),
    /*16*/  new Language('Әкесінің аты', 'Отчество'),
    /*17*/  new Language('ЖСН', 'ИИН'),
    /*18*/  new Language('Тестілеуді тапсырған тіл', 'Язык сдачи тестирования'),
    /*19*/  new Language('Жарамдылық мерзімі', 'Действителен до'),
    /*20*/  new Language('Тестілеу түрі', 'Вид тестирования'),
    /*21*/  new Language('Тестілеу атауы', 'Название теста'),
    /*22*/  new Language('Тестілеу жылы', 'Год тестирования'),
    /*23*/  new Language('Пәннің атауы', 'Название предмета'),
    /*24*/  new Language('Куәлік деректері', 'Данные свидетельства'),
    /*25*/  new Language('Тестілеу пәндері', 'Предметы тестирования'),
    /*26*/  new Language('Пәндер бойынша жалпы балл', 'Общий балл по предметам'),
    /*27*/  new Language('ТЖК', 'ИКТ'),
    /*28*/  new Language('Білім беру бағдарламаларының тобы', 'Группа образовательных программ'),
    /*29*/  new Language('ЖСН енгізіңіз', 'Введите ИИН'),
    /*30*/  new Language('Құжатты жүктеу', 'Скачать документ'),
    /*31*/  new Language('Білім беру бағдарламалары тобы', 'Группа образовательных программ'),
    /*32*/  new Language('ЖОО', 'ВУЗ'),
    /*33*/  new Language('Квота', 'Квота'),
    /*34*/  new Language('БІЛІМ ГРАНТТАРЫ КОНКУРСЫНЫҢ НӘТИЖЕЛЕРІ', 'РЕЗУЛЬТАТЫ КОНКУРСА ОБРАЗОВАТЕЛЬНЫХ ГРАНТОВ'),
    /*35*/  new Language('Оқыту мерзімі', 'Срок обучения'),
    /*36*/  new Language('Бағыты', 'Направление'),
    /*37*/  new Language('Республикалық конкурстық комиссияның шешімі бойынша, Сіз бакалавриаттың білім беру бағдарламалары тобы бойынша білім грантының иегері болып табылмайсыз', 'По решению Республиканской конкурсной комиссии, Вы не являетесь обладателем государственного образовательного гранта по группе образовательных программ бакалавриата'),
    /*38*/  new Language('Республикалық конкурстық комиссияның шешімі бойынша, Сіз магистратураның білім беру бағдарламалары тобы бойынша білім грантының иегері болып табылмайсыз', 'По решению Республиканской конкурсной комиссии, Вы не являетесь обладателем государственного образовательного гранта по группе образовательных программ магистратуры'),
    /*39*/  new Language('Республикалық конкурстық комиссияның шешімі бойынша, Сіз бакалавриаттың білім беру бағдарламалары тобы бойынша білім грантының иегері болып табыласыз', 'По решению Республиканской конкурсной комиссии, Вы являетесь обладателем государственного образовательного гранта по группе образовательных программ бакалавриата'),
    /*40*/  new Language('Республикалық конкурстық комиссияның шешімі бойынша, Сіз магистратураның білім беру бағдарламалары тобы бойынша білім грантының иегері болып табыласыз', 'По решению Республиканской конкурсной комиссии, Вы являетесь обладателем государственного образовательного гранта по группе образовательных программ магистратуры'),
  ];




  getLang(): Observable<Language[]> {
    return Observable.from([this.Lang]);
  }



}





// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/model/lang.data.ts